import Layout from "../../../components/Layout";
import useStyles from "../styles";
import BreadCrumb from "../../../components/BreadCrumb/Breadcrumb";
import { Grid } from "@mui/material";
import Badge from "../../../components/Badge/Badge";
import Button from "../../../components/Button/Button";
import { httprequest } from "../../../data/api";
import { useParams, useSearchParams } from "react-router-dom";
import { useState, useEffect, useRef } from "react";
import { ToastContainer, toast } from "react-toastify";
import PageLoader from "../../../components/PageLoader/pageloader";
import nocomment from "../../../assets/images/nocomment.png";
import { Icon } from "@iconify/react/dist/iconify.js";
// import TextAreaGroup from "../../../components/FormComponent/TextAreaGroup";
import { useUserState } from "../../../context/UserContext";
import parse from "html-react-parser";
import ReactQuill from "react-quill";
import Modal from "../../../components/Modal/index";

const GET_TICKET_BY_ID = "/admin/v1/view-ticket/";
const REPLY_ADMIN = "/admin/v1/ticket/reply/";
const POST_COMMENT = "/admin/v1/ticket/comment/";
const CLOSE_TICKET = "/admin/v1/ticket-notifications/";
const COMMENTS_ENDPOINT = "/admin/v1/tickets/comments/";
const UPLOAD_ENDPOINT = "/api/v1/upload";

const ViewTicket = () => {
  const { id } = useParams();
  const [isLoading, setIsLoading] = useState(false);
  const [searchParams] = useSearchParams();
  const supportTicketId = searchParams.get("support_ticket_id");
  const [isClosing, setIsClosing] = useState(false);
  const classes = useStyles();
  const [comments, setComments] = useState([]);
  const [newComment, setNewComment] = useState("");
  const [ticketDetails, setTicketDetails] = useState([]);
  const [replyComment, setReplyComment] = useState("");
  const [sendingMessage, setSendingMessage] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [replyToCommentId, setReplyToCommentId] = useState(null);
  const [viewImages, setViewImages] = useState(false);
  const [selectedImageUrl, setSelectedImageUrl] = useState(null);
  const { profile } = useUserState();

  const commentsEndRef = useRef(null);
  const scrollToBottom = () => {
    if (commentsEndRef.current) {
      commentsEndRef.current.scrollIntoView({ behavior: "smooth" });
    }
  };

  const handleViewImages = () => {
    setViewImages(false);
    setSelectedImageUrl(null);
  };
  /**
 * Prevents file drop (e.g., images) into the Quill editor.
 *
 * @param {DragEvent} event - The drag event.
 */
  const handleEditorDrop = (event) => {
    if (event.dataTransfer && event.dataTransfer.files && event.dataTransfer.files.length > 0) {
      // Prevent drop if it's a file (e.g., image)
      event.preventDefault();
      event.stopPropagation();
    }
  };

  /**
 * Handles changes from the Quill editor (rich text input).
 * Updates the `lesson_outline` field in the noteForm state.
 *
 * @param {string} e - The HTML string content from Quill editor.
 */
  const handleQuillChange = (e) => {
    setNewComment(e);
  };

  /**
 * Defines allowed formatting options for the Quill editor.
 * Disallows embedding images or videos.
 *
 * @type {string[]}
 */
  const Quillformats = ["background", "bold", "color", "font", "code", "italic", "link", "size",
    "strike", "script", "underline", "blockquote", "header", "indent", "list", "align", "direction", "code-block", "formula"
    // 'image'
    // 'video'
  ];

  /**
 * Prevents image pasting into the Quill editor.
 *
 * @param {ClipboardEvent} event - The paste event.
 */
  const handlePaste = (event) => {
    const items = event.clipboardData.items;
    for (let i = 0; i < items.length; i++) {
      // Check if any pasted item is an image
      if (items[i].type.indexOf("image") !== -1) {
        event.preventDefault(); // Prevent the paste

        return;
      }
    }
  };

  const formatTime = (dateString) => {
    const dateObject = new Date(dateString);

    const day = dateObject.getUTCDate().toString().padStart(2, "0");
    const month = (dateObject.getUTCMonth() + 1).toString().padStart(2, "0");
    const hours = dateObject.getUTCHours().toString().padStart(2, "0");
    const minutes = dateObject.getUTCMinutes().toString().padStart(2, "0");

    return `${hours}:${minutes}  ${month}/${day}`;
  };

  const handleCancelReply = () => {
    setReplyToCommentId(null);
    setReplyComment("");
  };

  const handleFileChange = (e) => {
    if (e.target.files) setSelectedFile(e.target.files[0]);
  };

  const handleRemoveFile = () => {
    setSelectedFile(null);
  };

  const fetchComments = () => {
    httprequest
      .get(`${COMMENTS_ENDPOINT}${supportTicketId}`)
      .then((res) => {
        const fetchedComments = res?.data?.data || [];

        // Combine comments and replies into a single array
        const combinedCommentsAndReplies = fetchedComments.flatMap(comment => {
          const commentEntry = { ...comment, type: "comment" };
          const replyEntries = comment.replies.map(reply => ({ ...reply, type: "reply", parentCommentId: comment.id, ref_type: comment?.ref_type }));

          return [commentEntry, ...replyEntries];
        });

        // Sort by the created_at field (chronologically)
        combinedCommentsAndReplies.sort(
          (a, b) => new Date(a.created_at) - new Date(b.created_at)
        );

        setComments(combinedCommentsAndReplies);
        scrollToBottom();
      })
      .catch(() => {
        toast.error("Failed to fetch comments");
      });
  };

  const handleAddComment = async () => {
    setSendingMessage(true);
    try {
      let uploadedImages = {};
      if (selectedFile) {
        const formData = new FormData();
        formData.append("file", selectedFile);
        const response = await httprequest.post(`${UPLOAD_ENDPOINT}`, formData);

        if (response.status === 200 && response?.data?.data) {
          const { upload_id, file_url } = response.data.data[0];
          uploadedImages = { upload_id, file_url };
        }
        // Append the new comment to the existing comments
        const updatedComments = newComment;
        if (updatedComments === "") {
          toast.error("Enter Comment.");

          return;
        }

        const payload = { comment: updatedComments, support_ticket_id: supportTicketId, attachment: uploadedImages };

        await httprequest.post(`${POST_COMMENT}${profile?.role?.id}`, payload);
        toast.success("Comment added successfully");
        setNewComment("");
        fetchComments();
        setComments();
        setSendingMessage(false);
      } else {
        // Append the new comment to the existing comments
        const updatedComments = newComment;
        if (updatedComments === "") {
          toast.error("Enter Comment.");

          return;
        }

        const payload = { comment: updatedComments, support_ticket_id: supportTicketId };

        await httprequest.post(`${POST_COMMENT}${profile?.role?.id}`, payload);
        toast.success("Comment added successfully");
        setNewComment("");
        fetchComments();
        setComments();
        setSendingMessage(false);
      }
    } catch (err) {
      setSendingMessage(false);
      toast.error(err?.response?.data || "Failed to add comment");
    }
  };

  const handleReplyComment = async () => {
    setSendingMessage(true);

    try {
      if (!replyToCommentId || !replyComment) {
        toast.error("No comment or reply text provided.");

        return;
      }

      let uploadedImages = null;

      if (selectedFile) {
        const formData = new FormData();
        formData.append("file", selectedFile);

        const response = await httprequest.post(`${UPLOAD_ENDPOINT}`, formData);

        if (response.status === 200 && response?.data?.data) {
          const { upload_id, file_url } = response.data.data[0];
          uploadedImages = { upload_id, file_url };
        }
      }

      const payload = {
        reply: replyComment,
        comment_id: replyToCommentId,
        ...(uploadedImages && { attachment: uploadedImages })
      };

      await httprequest.patch(`${REPLY_ADMIN}${profile?.role?.id}`, payload);

      toast.success("Reply added successfully");
      setReplyComment("");
      setReplyToCommentId(null);
      fetchComments();
    } catch (err) {
      toast.error(err?.response?.data || "Failed to add reply");
    } finally {
      setSendingMessage(false);
    }
  };

  const getTicketById = () => {
    setIsLoading(true);
    httprequest(`${GET_TICKET_BY_ID}${id}`)
      .then((res) => {
        setIsLoading(false);
        setTicketDetails(res?.data?.data);
      })
      .catch((err) => {
        setIsLoading(false);
        toast.error(err?.response?.data?.message);
      });
  };

  const handleReplyClick = (commentId) => {
    setReplyToCommentId(commentId);
    setReplyComment("");
  };

  useEffect(() => {
    fetchComments();
    getTicketById();
  }, []);

  const handleCloseTicket = () => {
    setIsClosing(true);
    httprequest
      .patch(`${CLOSE_TICKET}${id}`, { status: "closed" })
      .then((res) => {
        toast.success(res?.data?.message);
        setIsClosing(false);
        getTicketById();
        fetchComments();
      })
      .catch((err) => {
        setIsClosing(false);
        toast.error(err?.response?.data?.message);
      });
  };

  return (
    <Layout
      children={
        <>
          <div className="breadcrumb-container">
            <div>
              <BreadCrumb
                link_one="/support/tickets"
                link_one_name="Tickets"
                active="View Ticket"
                description="View your ticket information here"
              />
            </div>
          </div>
          <div className="page-content">
            <div className={`${classes.previewsubheader} text-align-left`}>
              <div>
                <h3>{`#${ticketDetails?.ticket_number || "--/--"}  -  ${ticketDetails?.subject || "--/--"}`}</h3>
              </div>
            </div>
            {ticketDetails?.status === "closed" ? (
              <p className="ticket-closed">
            This ticket is closed. You may reply to this ticket to reopen it.
              </p>
            ) : null}
            <Grid container spacing={4} sx={{
              "@media (max-width:430px)": {
                flexDirection: "column-reverse"
              }
            }}
            >
              <Grid item lg={4} md={5} sm={12} xs={12}>
                <div className="left-container container-border">
                  <h4>Ticket Information</h4>
                  {isLoading ? (
                    <PageLoader />
                  ) : (
                    <div className={classes.details}>
                      <Grid container spacing={2}>
                        <Grid item lg={12} md={12} sm={12} xs={12}>
                          <div className={`${classes.previewsubheader} text-align-left`}>
                            <div>
                              <p>Ticket Number</p>
                              <h4>{ticketDetails?.ticket_number || "--/--"}</h4>
                            </div>
                          </div>
                        </Grid>
                        <Grid item lg={12} md={12} sm={12} xs={12}>
                          <div className={`${classes.previewsubheader} text-align-left`}>
                            <div>
                              <p>Name</p>
                              <h4>{`${ticketDetails?.last_name || "--/--"} ${ticketDetails?.first_name || "--/--"}`}</h4>
                            </div>
                          </div>
                        </Grid>
                        <Grid item lg={12} md={12} sm={12} xs={12}>
                          <div className={`${classes.previewsubheader} text-align-left`}>
                            <div>
                              <p>Email</p>
                              <h4>{ticketDetails?.email || "--/--"}</h4>
                            </div>
                          </div>
                        </Grid>
                        <Grid item lg={12} md={12} sm={12} xs={12}>
                          <div className={`${classes.previewsubheader} text-align-left`}>
                            <div>
                              <p>Priority</p>
                              <h4><Badge status={ticketDetails?.priority} /></h4>
                            </div>
                          </div>
                        </Grid>
                        <Grid item lg={6} md={6} sm={12} xs={12}>
                          <div className={`${classes.previewsubheader} text-align-left`}>
                            <div>
                              <p>Date Created</p>
                              <h4>{ticketDetails?.created_at?.substring(0, 10) || "--/--"}</h4>
                            </div>
                          </div>
                        </Grid>
                        {ticketDetails?.attachment?.file_url && (
                          <Grid item lg={6} md={6} sm={12} xs={12}>
                            <div className={`${classes.previewsubheader} text-align-left`}>
                              <div className={classes.viewimg}>
                                <p>Attachment</p>
                                <h4 onClick={() => {
                                  setSelectedImageUrl(ticketDetails?.attachment?.file_url);
                                  setViewImages(true);
                                }}
                                >View Attachment
                                </h4>
                              </div>
                            </div>
                          </Grid>
                        )}
                        <Grid item lg={12} md={12} sm={12} xs={12}>
                          <div className={`${classes.previewsubheader} text-align-left`}>
                            <div>
                              <p>User Comment</p>
                              <h4>Great experience</h4>
                            </div>
                          </div>
                        </Grid>
                        <Grid item lg={12} md={12} sm={12} xs={12}>
                          <div className={`${classes.previewsubheader} text-align-left`}>
                            <div>
                              <p>User Rating</p>
                              <div className={classes.starss}>
                                {[...Array(5)].map((_, i) => i < 3 ? "★" : "☆"
                                )}
                              </div>
                            </div>
                          </div>
                        </Grid>
                      </Grid>
                    </div>
                  )}
                  {ticketDetails?.status === "open" && (
                    <Button
                      variant="primary"
                      buttonSize="full"
                      color="btndefault"
                      isLoading={isClosing}
                      onClick={handleCloseTicket}
                      buttonName="Close Ticket"
                    />
                  )}
                </div>
              </Grid>
              <Grid item lg={8} md={7} sm={12} xs={12}>
                <div className="support-right-container relative-full container-border">
                  <div className="support-section-top">
                    <div className={`${classes.previewsubheader} text-align-left`}>
                      <div>
                        <h5>{`#${ticketDetails?.ticket_number || "--/--"}  -  ${ticketDetails?.subject || "--/--"}`}</h5>
                      </div>
                    </div>
                    <div className={`${classes.subjectitems} text-align-left`}>
                      <div>
                        <h5>{`${ticketDetails?.message || "--/--"}`}</h5>
                      </div>
                    </div>
                  </div>
                  <div className="all-support-chat-height">
                    {Array.isArray(comments) && comments.length > 0 ? (
                      <div className="support_comment_div application_comment">
                        {comments.map((item, index) => (
                          <div key={index} className={`admin_comment ${
                            item?.ref_type === "super_admin" && item?.user?.id
                              ? item?.user?.id === profile?.user_id
                                ? "user"
                                : item?.ref_type
                              : item?.ref_type
                          }`}
                          >
                            {item?.image?.file_url && (
                              <img
                                src={item?.image?.file_url}
                                alt="preview"
                                className={classes.chatimage}
                                onClick={() => {
                                  setSelectedImageUrl(item?.image?.file_url);
                                  setViewImages(true);
                                }}
                              />
                            )}
                            {item?.type === "comment" ? (
                              <div className="comment_main">

                                <div className="apply comment_container">
                                  <p className=" no_margin">
                                    <strong>{item?.user?.name}</strong>
                                  </p>
                                  <span className="admin_comment_span">{parse(item?.comment)}
                                    <div className="comment_time justify_end">{formatTime(item?.created_at)}</div>

                                  </span>
                                  {(item?.ref_type === "user" || item?.ref_type === "super_admin") && (
                                    <span
                                      className="reply"
                                      onClick={() => handleReplyClick(item.id)}
                                    >
                                      Reply
                                    </span>

                                  )}
                                </div>
                              </div>
                            ) : (
                              <div className={`reply_container_${
                                item?.ref_type === "super_admin" && item?.user?.id !== profile?.role?.id
                                  ? "user"
                                  : item?.ref_type === "user" && item?.user?.id === profile?.role?.id
                                    ? "super_admin"
                                    : item?.ref_type
                              }`}
                              >
                                <div className="reply_main">
                                  {/* <p className="reply-user  no_margin">
                                    <strong>{item?.user?.last_name}</strong>
                                  </p> */}
                                  <div className="original-comment">
                                    <div className="reply_com">
                                      {/* <p className="original-comment-user no_margin">
                                        <strong>{comments.find(comment => comment?.id === item.parentCommentId)?.user?.last_name}</strong>
                                      </p> */}
                                      <span>
                                        {parse(comments.find(comment => comment?.id === item?.parentCommentId)?.comment)}
                                      </span>
                                    </div>
                                    <span>
                                      {parse(item?.reply)}
                                    </span>
                                    <div className="comment_time">{formatTime(item?.created_at)}</div>
                                  </div>

                                  {/* {(item?.ref_type === "user" || item?.ref_type === "super_admin") && (
                                    <span
                                      className="reply justify_end"
                                      onClick={() => handleReplyClick(comments.find(comment => comment?.id === item.parentCommentId)?.id)}
                                    >
                                    Reply
                                    </span>
                                  )} */}

                                </div>
                              </div>
                            )}
                          </div>
                        ))}
                      </div>
                    ) : (
                      <div className="no_upload no_upload_centering">
                        <img src={nocomment} />
                        <p>No Chat available</p>
                      </div>
                    )}
                  </div>
                  <div className={`${classes.fortextarea} margin-top-12 support-section-bottom`}>
                    {/* Default comment submission area, hidden when replying */}
                    {!replyToCommentId && (
                      <Grid item lg={12} md={12} sm={12} xs={12}>
                        <Grid container spacing={2}>
                          {selectedFile && (
                            <Grid item lg={12} md={12} sm={12} xs={12}>
                              <div className={classes.previewGrid}>
                                <div className={classes.previewItem}>
                                  <img
                                    src={URL.createObjectURL(selectedFile)}
                                    alt="preview"
                                    className={classes.previewImage}
                                  />
                                  <div
                                    className={classes.removeBtn}
                                    onClick={() => handleRemoveFile()}
                                  >
                                    <Icon icon="mdi:remove-bold" />
                                  </div>
                                </div>
                              </div>
                            </Grid>
                          )}
                        </Grid>
                        <div className={`${classes.quillposition} margin-top-40`}>
                          <ReactQuill
                            theme="snow"
                            onDrop={handleEditorDrop}
                            onChange={handleQuillChange}
                            onPaste={handlePaste}
                            formats={Quillformats}
                            modules={{
                              toolbar: [
                                [{ "header": [1, 2, false] }],
                                ["bold", "italic", "underline"],
                                [{ "list": "ordered" }, { "list": "bullet" }],
                                ["clean"]
                              ]
                            }}
                            value={newComment}
                            style={{
                              minHeight: "100px",
                              borderRadius: 20,
                              textAlign: "left",
                              border: "none",
                              "& qlContainer": { height: "100px" }
                            }}
                          />
                          <div className="flex gap-10 justifyRight margin-top-5 margin-right-bottom-8">
                            <div className={classes.addimages}>
                              <input
                                type="file"
                                multiple
                                className={classes.pickimage}
                                onChange={handleFileChange}
                                style={{ border: "1px solid red" }}
                                name="file"
                                accept="image/jpeg,image/jpe,image/png"
                              />
                            Attach image <Icon icon="tdesign:attach" style={{ color: "#0065FF" }} />
                            </div>
                            <div className="send_comment flex" onClick={handleAddComment}>
                              {sendingMessage ? "Sending" : "Send"} <Icon icon="zondicons:send" />
                            </div>
                          </div>
                        </div>
                      </Grid>
                    )}

                    {/* Reply form, shown only when replying to a comment */}
                    {replyToCommentId && (
                      <div className="reply_div">
                        <div className="selected-comment-to-reply">
                          <div>
                            <span>
                              {comments.find(comment => comment.id === replyToCommentId)?.user?.last_name}
                            </span>
                            <p className="no_margin text-align-left">
                              {parse(comments.find(comment => comment.id === replyToCommentId)?.comment)}
                              {comments.find(comment => comment.id === replyToCommentId)?.replies.reply}
                            </p>
                          </div>
                          <button className="cancel_reply" onClick={handleCancelReply}>
                            <Icon icon="ic:outline-cancel" />
                          </button>
                        </div>

                        <Grid container spacing={2}>
                          {selectedFile && (
                            <Grid item lg={12} md={12} sm={12} xs={12}>
                              <div className={classes.previewGrid}>
                                <div className={classes.previewItem}>
                                  <img
                                    src={URL.createObjectURL(selectedFile)}
                                    alt="preview"
                                    className={classes.previewImage}
                                  />
                                  <div
                                    className={classes.removeBtn}
                                    onClick={() => handleRemoveFile()}
                                  >
                                    <Icon icon="mdi:remove-bold" />
                                  </div>
                                </div>
                              </div>
                            </Grid>
                          )}
                        </Grid>
                        <div className={`${classes.quillposition} margin-top-40`}>
                          <ReactQuill
                            theme="snow"
                            onDrop={handleEditorDrop}
                            onChange={(e) => setReplyComment(e)}
                            onPaste={handlePaste}
                            formats={Quillformats}
                            modules={{
                              toolbar: [
                                [{ "header": [1, 2, false] }],
                                ["bold", "italic", "underline"],
                                [{ "list": "ordered" }, { "list": "bullet" }],
                                ["clean"]
                              ]
                            }}
                            value={replyComment}
                            style={{
                              minHeight: "100px",
                              borderRadius: 20,
                              textAlign: "left",
                              border: "none",
                              "& qlContainer": { height: "100px" }
                            }}
                          />
                          <div className="flex gap-10 justifyRight margin-top-5 margin-right-bottom-8">
                            <div className={classes.addimages}>
                              <input
                                type="file"
                                multiple
                                className={classes.pickimage}
                                onChange={handleFileChange}
                                style={{ border: "1px solid red" }}
                                name="file"
                                accept="image/jpeg,image/jpe,image/png"
                              />
                            Attach image <Icon icon="tdesign:attach" style={{ color: "#0065FF" }} />
                            </div>
                            <div className="send_comment flex" onClick={handleReplyComment}>
                              {sendingMessage ? "Replying" : "Reply"} <Icon icon="zondicons:send" />
                            </div>
                          </div>
                        </div>

                        {/* Reply text area */}
                        {/* <TextAreaGroup
                          margin="normal"
                          inputType="text"
                          inputName="replyComment"
                          value={replyComment}
                          onChange={(e) => setReplyComment(e.target.value)}
                        />
                        <button className="upload_comment flex justify_end" onClick={handleReplyComment}>
                            Reply Message <Icon icon="zondicons:send" />
                        </button> */}
                      </div>
                    )}
                  </div>
                </div>
              </Grid>
            </Grid>
          </div>
          {/* Attachment Modal */}
          <Modal
            title="Attachments"
            subtitle={
              <div>View attachment
              </div>}
            modalContent={
              <>
                <Grid container spacing={2}>
                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    <img
                      src={selectedImageUrl}
                      alt="Attachment Preview"
                      style={{ maxWidth: "100%", height: "auto" }}
                    />
                  </Grid>
                </Grid>
              </>
            }
            modalFooter={
              <>
              </>
            }
            isopen={viewImages}
            closeModal={handleViewImages}
          />
          <ToastContainer />
        </>
      }
    />
  );
};

export default ViewTicket;
